import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import { getDuration } from "../../store/helpers/common_functions";
import { Progress } from "reactstrap";
import moment from "moment";
import { useHistory } from "react-router";
import StatusLayout from "components/Status";
import axios from "axios";
import SubmitProjectReportDialog from "../../helpers/SubmitProjectReport";
import Paper from "@mui/material/Paper";
import { CircularProgress, Button, Dialog, DialogContent, DialogTitle, Link, Tooltip, Chip } from "@mui/material";
import { errorToast, successToast } from "../../helpers/Notification";
import JoditEditorExample from "../../helpers/JoditEditorExample";

function ProjectManagement({ location, SetSelectedMenu, loggedUser, resources }) {
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [id, setId] = React.useState();
    const [count, setCount] = React.useState(0);
    const [selected, setSelected] = React.useState(location.state?.status ?? "all");
    const [openSubmitDialog, setOpenSubmitDialog] = React.useState(false);
    const [processedData, setProcessedData] = React.useState([]);
    const [period, setPeriodState] = React.useState({
        startDate: moment().startOf("W"),
        endDate: moment().endOf("W"),
    });
    const [dataToEdit, setDataToEdit] = React.useState({});
    const [projectId, setProjectId] = React.useState();
    const [addNew, setAddNew] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const formRef = React.useRef(null);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [viewChallenge, setViewChallenge] = React.useState(false);
    const handleSubmitSuccess = () => {
        setCount((v) => v + 1);
        // setOpenSubmitDialog(false); 
    };

    const updatePeriod = (newPeriod) => {
        setPeriodState(newPeriod);
    };

    const history = useHistory();

    useEffect(() => {
        setSelected(location.state?.status ?? "all");
    }, [location.state]);


    useEffect(() => {
        SetSelectedMenu({
            menu: "report/projects",
            title: "Projects Report"
        })
    }, []);

    const renderChallengeModal = () => (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <JoditEditorExample
                    htmlContent={dataToEdit?.challenge ?? ''}
                    onBlur={(str) => setDataToEdit((prev) => ({ ...prev, challenge: str.target.value }))}
                />
                {validationErrors.challenge && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {validationErrors.challenge}
                    </div>
                )}
            </div>
        </div>
    );


    const updateTask = async () => {
        if (!projectId) return errorToast('Server error. Please try again later');

        setLoading(true);
        try {
            const response = await axios.post(`/api/project/update/challenge/${projectId}`, { challenge: dataToEdit.challenge });
            successToast('Project updated successfully');

            setAddNew(false);
            setDataToEdit({});
            setValidationErrors({});
        } catch (error) {
            setValidationErrors({ description: error.message });
        } finally {
            setLoading(false);
            onSuccess();
        }
    };

    const form = (
        <form ref={formRef} onSubmit={(e) => {
            e.preventDefault();
            updateTask().then((response) => {
                if (response.status === 200) {
                    successToast('Project updated successfully');
                    setAddNew(false);
                    setDataToEdit({});
                    setValidationErrors({});
                } else {
                    setValidationErrors(response.data);
                }
            }).catch((error) => {
                setValidationErrors({ description: error.message });
            });
        }}>
            {renderChallengeModal()}
            <div className={'px-2'} style={{ display: 'flex', marginTop: '1rem' }}>
                {loading ? <CircularProgress /> :
                    <>
                        <Button
                            variant={'contained'}
                            color="error"
                            onClick={() => {
                                setAddNew(false);
                                setDataToEdit({});
                                setValidationErrors({});
                            }}
                        >
                            Cancel
                        </Button>
                        <Button style={{ marginLeft: '5px' }} variant={'contained'} type={'submit'}>
                            Create
                        </Button>
                    </>
                }
            </div>
        </form>
    );

    const columns = [
        {
            name:"code",
            label: "Code",

        },
        {
            name: "name",
            label: "Name",
        },
        {
            name: "program.name",
            label: "Program Name",
        },
        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "budget",
            label: "Budget"
        },
        {
            name: "impact",
            label: "Impact",
        },
        {
            name: "performance",
            label: "Performance",
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    let color =
                        status === "completed"
                            ? "success"
                            : status === "canceled"
                                ? "error"
                                : status === "pending review"
                                    ? "text-green-500"
                                    : status === "under review"
                                        ? "bg-secondary"
                                        : status === "missing information"
                                            ? "bg-black-500"
                                            : status === "forwarded"
                                                ? "bg-primary"
                                                : "info";
                    return (
                        <span
                            style={{ fontSize: "0.85rem" }}
                        >
                            <StatusLayout status={status} />
                        </span>

                    );
                },
            },
        },
        // {
        //     name: "id",
        //     label: "Action",
        //     options: {
        //         filter: false,
        //         sort: false,
        //         customBodyRender: (v) => (
        //             <div>
        //                 <BasicMenu
        //                     extra={[
        //                         {
        //                             label: "Edit Challenge",
        //                             icon: <i className="fas fa-pen text-sm"></i>,
        //                             onClick: async () => {
        //                                 try {
        //                                     const response = await axios.get(`/api/project/details/${v}`);
        //                                     setDataToEdit(response.data.project);
        //                                     setProjectId(v);
        //                                     setAddNew(true); 
        //                                 } catch (error) {
        //                                 } finally {
        //                                     setLoading(false);
        //                                 }
        //                             },
        //                         },
        //                     ]}
        //                 />
        //                 {addNew && projectId === v && (
        //                     <Dialog open={addNew} maxWidth={'lg'} fullWidth={true} onClose={() => setAddNew(false)}>
        //                         <DialogTitle>
        //                             Edit Challenge for Project: {dataToEdit?.name || "Unknown Task"}
        //                         </DialogTitle>
        //                         <DialogContent>{form}</DialogContent>
        //                     </Dialog>
        //                 )}
        //             </div>
        //         ),
        //     },
        // },
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }
    const onSuccess = () => setCount(v => v + 1);
    return <div className="w-full mb-12 px-4">
        <DatatableComponent
            columns={columns}
            pdf={true}
            excel={true}
            submitReport={true}
            search={false}
            searchfield={true}
            viewColumns={false}
            order={location.state?.order}
            url={`/api/report/projects/list?status=${selected}&count=${count}&startDate=${period.startDate}&endDate=${period.endDate}`}
            // url={`/api/report/projects/list?status=${selected}&count=${count}`}
            processData={(data) => {
                setProcessedData(data.data);
                setList(data.data);
                return data;
            }}

            onSubmitReport={() => {
                setOpenSubmitDialog(true);
            }}

            title={
                <div className="flex gap-4 items-center">
                  {/* From Date */}
                  <div className="flex items-center gap-2">
                    <label className="text-[#054163] font-medium">From</label>
                    <input
                      className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                      type="date"
                      value={
                        Date.parse(period?.startDate)
                          ? moment(period?.startDate).format("YYYY-MM-DD")
                          : ""
                      }
                      max={period.endDate}
                      onChange={(e) => {
                        updatePeriod({
                          ...period,
                          startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                        });
                      }}
                    />
                  </div>
              
                  <div className="flex items-center gap-2">
                    <label className="text-[#054163] font-medium">To</label>
                    <input
                      className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                      type="date"
                      value={
                        Date.parse(period?.endDate)
                          ? moment(period?.endDate).format("YYYY-MM-DD")
                          : ""
                      }
                      min={moment(period?.startDate).format("YYYY-MM-DD")}
                      onChange={(e) => {
                        updatePeriod({
                          ...period,
                          endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                        });
                      }}
                    />
                  </div>
              
                  {(period?.startDate || period?.endDate) && (
                    <button
                      className="text-blue-500 font-medium hover:underline"
                      onClick={async () => {
                        try {
                          setPeriodState({
                            startDate: null,
                            endDate: null,
                          });
              
                          setCount((prev) => prev + 1);
                        } catch (error) {
                        }
                      }}
                    >
                      Reset Date
                    </button>
                  )}
                </div>
              }

        />

        <SubmitProjectReportDialog
            open={openSubmitDialog}
            onClose={() => setOpenSubmitDialog(false)}
            onSuccess={handleSubmitSuccess}
            SubmitGeneralForm={async (url, formData) => {
                try {
                    const response = await axios.post(url, formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                    return { status: response.status === 200, data: response.data };
                } catch (error) {
                    return { status: false };
                }
            }}

            startDate={moment(period.startDate).format("YYYY-MM-DD")}
            endDate={moment(period.endDate).format("YYYY-MM-DD")}
            loggedUser={loggedUser}
            resources={resources}
            processData={processedData}

        />
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagement);
